enum PaymentState {
    PendingApproval = "PENDING_APPROVAL",
    UserCancelled = "USER_CANCELLED",
    UserRejected = "USER_REJECTED",
    Scheduled = "SCHEDULED",
    Submitted = "SUBMITTED",
    Accepted = "ACCEPTED",
    Rejected = "REJECTED",
    Processing = "PROCESSING",
    Completed = "COMPLETED",
    Failed = "FAILED",
    Expired = "EXPIRED",
    MonitoringHeld = "MONITORING_HELD",
    MonitoringRejected = "MONITORING_REJECTED",
}
export default PaymentState